import React, { Component } from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
    const getColor = (color) => {
        switch(color){
            case 'purple':
                return '#9013FE';
            case 'blue':
                return '#32ABE1';
            case 'yellow':
                return '#FCC974';
            case 'green':
                return '#96C944';
            case 'teal':
                return '#2DE6D5';
            case 'black':
                return '#9B9B9B';
            default:
                return '#9B9B9B';
        }
    }

    const style = {
        ...props.style,
        border: props.outlined ? '1px solid #9B9B9B' : null,
        color: props.disabled ? '#9B9B9B' : getColor(props.color),
        opacity: props.disabled ? 0.4 : 1,
    };
    
    return (
        <button
            className="btn"
            style={style} 
            disabled={props.disabled}
            onClick={props.onClick}
        >
            {props.children}
        </button>
    )
}

Button.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.oneOf(['purple','blue','yellow','green','black', 'teal']),
    disabled: PropTypes.bool,
};

Button.default = {
    disabled: false,
    color: 'blue',
};

export default Button;


// WEBPACK FOOTER //
// ./src/shared/components/Button.js